<template>
	<section class="page page-password-reset">
		<header class="push-bottom">
			<ChalkyBrandingBadge size="md" mode="dark" />
			<h2>Reset Password</h2>
		</header>

		<section class="reset-container">
			<ChalkyAuthenticationResetPassword
				v-bind:token="token"
				v-on:cancel="Handle_OnCancel"
				v-on:error="Handle_OnError"
				v-on:success="Handle_OnSuccess"
			/>
		</section>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import PageBase from '@/Core/Page.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package Page
	 * @project ChalkySticks Web App
	 */
	@Component
	export default class PagePasswordReset extends PageBase {
		/**
		 * Token from URL for password reset authorization
		 *
		 * @type string
		 */
		public token: string = '';

		/**
		 * Lifecycle hook: mounted
		 * Extract the token from the URL
		 *
		 * @return void
		 */
		@mounted
		public initializeComponent(): void {
			this.token = this.$route.params.token || '';
		}

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * Handle navigation to home page
		 *
		 * @return void
		 */
		protected Handle_OnCancel(): void {
			this.$router.push('/');
		}

		/**
		 * Handle password reset form submission
		 *
		 * @param Error e
		 * @return Promise<void>
		 */
		protected async Handle_OnError(e: Error): Promise<void> {
			alert(e.message || 'Could not reset password.');
		}

		/**
		 * @return Promise<void>
		 */
		protected async Handle_OnSuccess(): Promise<void> {
			await this.$alert.alert('Your password has been reset successfully.');
			this.$router.push('/');
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.page-password-reset {
		align-items: center;
		display: flex;
		flex-direction: column;
		height: 100%;
		justify-content: center;
		text-align: center;
	}
</style>
